cv.TeamInviteView = Marionette.LayoutView.extend({
  className : 'modal-team-invite',

  template: cv.Templates['team/invite'],

  events: {
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);

    console.log('TeamInviteView initialized');
  },

  templateHelpers: function () {
    return {
    };
  },

  onAttach: function(){
    var url = cv.campaign.get('url') + '/signup?team_id='  + this.options.team_id;
    
    if(!_.isUndefined(url)){
      this.$('a').data('url', url);
      this.$('.share-url').text(url);
      this.$('.share-url').attr('data-clipboard-text', url);
      this.$('.copy-share-url').attr('data-clipboard-text', url);
    }else{
      this.$('a').data('url', top.location);
      this.$('.share-url').text(top.location);
      this.$('.share-url').attr('data-clipboard-text', top.location);
      this.$('.copy-share-url').attr('data-clipboard-text', top.location);
    }

    var clipboard = new Clipboard('.share-url, .copy-share-url');   
    clipboard.on('success', function(e) {
      console.info('action:', e.action);
      console.info('text:', e.text);
      console.info('trigger:', e.trigger);

      vent.trigger('notif:success', 'Link copied to clipboard.');
  
      e.clearSelection();
    });
  },

  onDestroy: function(){
  }
});